import './assets/scss/theme.scss';
import 'katex/dist/katex.min.css';
import './custom.css';
import React from 'react';
import { IntlProvider } from 'react-intl';
import ModalLoaderProvider from 'src/components/ModalLoader/Provider';
import { ConfirmContextProvider, ConfirmDialog } from 'src/components/ConfirmModal';

import { AppRoutes } from 'src/routes/app-routes';
import { Toaster } from 'src/components/ui/toaster';
import AppUpdateDialog from 'src/features/sw-update/app-update-dialog';
import { WebViewAuthInitializer } from 'src/components/auth/webview-auth-initializer';
import { WebViewWizardInitializer } from 'src/components/webview/webview-wizard-initializer';
import { GlobalToastProvider } from 'src/contexts/GlobalToastContext';
import { GlobalErrorBoundary } from 'src/components/error-boundary';
import { NetworkStatusIndicator } from 'src/components/network-status';

const App: React.FC = () => {
  return (
    <ModalLoaderProvider>
      <ConfirmContextProvider>
        <GlobalToastProvider>
          <IntlProvider locale={'en'}>
            <GlobalErrorBoundary>
              <Toaster />
              <AppUpdateDialog />
              <WebViewAuthInitializer />
              <WebViewWizardInitializer />
              <AppRoutes />
              <ConfirmDialog />
              <NetworkStatusIndicator />
            </GlobalErrorBoundary>
          </IntlProvider>
        </GlobalToastProvider>
      </ConfirmContextProvider>
    </ModalLoaderProvider>
  );
};

export default App;
